import { Injectable } from "@angular/core";
import { DataAccessService } from "@kells/apis/data-access";
import {
  Portals,
  QueryParameters,
} from "apps/patient-reporting/src/app/shared/enums/query.enums";
import { map } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { SubscriptionPlan } from "@kells/interfaces/patient";
import { URLService } from "../services";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  constructor(
    public readonly data: DataAccessService,
    private readonly urlService: URLService
  ) {}

  isAetna$ = this.data.patientOrganizationsNames$.pipe(
    map((patientOrganizationsNames) =>
      patientOrganizationsNames.some(
        (name) => name?.toLowerCase() === Portals.Aetna.toLowerCase()
      )
    )
  );

  isOralLink$ = this.data.patientOrganizationsNames$.pipe(
    map((patientOrganizationsNames) =>
      patientOrganizationsNames.some(
        (name) => name?.toLowerCase() === Portals.OralLink.toLowerCase()
      )
    )
  );

  isDentalSavers$ = this.data.patientOrganizationsNames$.pipe(
    map((patientOrganizationsNames) =>
      patientOrganizationsNames.some(
        (name) => name?.toLowerCase() === Portals.DentalSavers.toLowerCase()
      )
    )
  );

  get isLocalStorageAvailable(): boolean {
    return typeof window !== "undefined" && !!window.localStorage;
  }

  set localStoragePortal(portal: Portals | null) {
    if (!this.isLocalStorageAvailable) return;

    localStorage.setItem(QueryParameters.Portal, portal || "");
  }

  get localStoragePortal(): Portals | null {
    if (!this.isLocalStorageAvailable) return null;

    return localStorage.getItem(QueryParameters.Portal) as Portals;
  }

  set localStoragePlan(plan: SubscriptionPlan | null) {
    if (!this.isLocalStorageAvailable) return;

    localStorage.setItem(QueryParameters.Plan, plan || "");
  }

  get localStoragePlan(): SubscriptionPlan | null {
    if (!this.isLocalStorageAvailable) return null;

    return localStorage.getItem(QueryParameters.Plan) as SubscriptionPlan;
  }

  public resetPlanSettings() {
    this.urlService.removeQueryParam(QueryParameters.Plan);
    this.localStoragePlan = null;
  }

  public resetPortalSettings() {
    this.urlService.removeQueryParam(QueryParameters.Portal);
    this.localStoragePortal = null;
  }

  public resetPortalAndPlanSettings() {
    this.urlService.removeQueryParam([QueryParameters.Portal, QueryParameters.Plan]);
    this.localStoragePortal = null;
    this.localStoragePlan = null;
  }

  public readonly treatmentVerificationLink$ = combineLatest([
    this.data.selectedPatientHasFullAppAccess$,
    this.isAetna$,
  ]).pipe(
    map(([hasFullAppAccess, isAetna]) => {
      if (isAetna) {
        return "https://form.jotform.com/240908138742156";
      }

      return hasFullAppAccess
        ? "https://form.jotform.com/242393220296152"
        : "https://form.jotform.com/232995196179171";
    })
  );
}
